import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps } from "aaa";
import ErrorScreen from "components/common/ErrorScreen";
import { ui } from "components/util/uiHelpers";
import { Switch } from "react-router";
import externalInterfaceStore, { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { history } from "stores/RouterStore";
import CardTanSettingsContainer from "./cardTanSettings/CardTanSettingsContainer";
import GidSettingsContainer from "./gidSettings/GidSettingsContainer";
import { LoginManagementRoutes } from "./LoginManagementRoutes";
import { LoginManagementSite } from "./LoginManagementSite";
import { LoginManagementStore } from "./LoginManagementStore";
import SIdentitySettingsContainer from "./sIdentitySettings/SIdentitySettingsContainer";

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class LoginManagementContainer extends React.Component<IProps> {
    store: LoginManagementStore;

    constructor(props: IProps) {
        super(props);
        this.store = new LoginManagementStore();
    }

    async componentDidMount() {
        if (history.location.pathname === LoginManagementRoutes.ROOT || history.location.pathname === `${LoginManagementRoutes.ROOT}/`) {
            try {
                await this.store.load();

                const authorizationType = externalInterfaceStore.settings?.authorizationType;

                if (authorizationType === "CARDTAN") {
                    pushRoute(LoginManagementRoutes.CARDTAN);
                } else if (authorizationType === "SID") {
                    pushRoute(LoginManagementRoutes.SID);
                } else if (authorizationType === "GEORGE_TOKEN") {
                    pushRoute(LoginManagementRoutes.GID);
                } else {
                    // TAC should not be possible anymore therefor got to error page
                    pushRoute("/error");
                }
            } catch (error) {
                debug.log("### LoginManagementContainer.componentDidMount() Failed to load data", error);

                if (!config.DEBUG) {
                    pushRoute("/error");
                }
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    withMessage(Component: any, message: string, hideButton?: boolean) {
        return () => <Component {...this.props} useWebVersion variant="error" message={message} hideButton={hideButton} />;
    }

    render() {
        return (
            <div>
                <Switch>
                    <Route exact path={LoginManagementRoutes.ROOT} component={this.withStore(LoginManagementSite)} />
                    <Route path={LoginManagementRoutes.CARDTAN} component={CardTanSettingsContainer} />
                    <Route path={LoginManagementRoutes.SID} component={SIdentitySettingsContainer} />
                    <Route path={LoginManagementRoutes.GID} component={GidSettingsContainer} />
                    <Route render={this.withMessage(ErrorScreen, ui.__("error.pageNotFound"), true)} />
                </Switch>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/LoginManagementContainer.tsx